import { render } from "./BiosampleMetadataImportDialog.vue?vue&type=template&id=5e1952a7&scoped=true"
import script from "./BiosampleMetadataImportDialog.vue?vue&type=script&lang=js"
export * from "./BiosampleMetadataImportDialog.vue?vue&type=script&lang=js"

import "./BiosampleMetadataImportDialog.vue?vue&type=style&index=0&id=5e1952a7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1952a7"]])

export default __exports__